import * as React from 'react'
import { observer } from 'mobx-react'
import { cartStore } from '../../cart'
import { AddToOrder } from '../add-to-order'
import { IProduct } from '../product.interfaces'
import './product-quantity.scss'
import { RemoveFromCart, RemoveFromCartIcon } from '../remove-from-cart'

interface IProps extends IProduct {
  className?: string
  displayUnavailable?: boolean
  productIsAvailable?: boolean
}

@observer
export class ProductQuantity extends React.Component<IProps> {
  state = {
    quantity: 0
  }

  componentDidMount(): void {
    const quantity = Number(cartStore.itemQuantityInputs.get(this.props.id))
    if (!isNaN(quantity)) {
      this.setState({ quantity })
    }
  }

  setItemQuantityInput = (quantityInput: string): void => {
    // @TODO Add `&& parseInt(quantityInput, 10) <= product.maxQuantity`
    // when maxQuantity prop has been determined in Shopify admin
    const valid = /^\d+$/.test(quantityInput)
    if (quantityInput.length > 0 && !valid) {
      return
    }
    this.setState({ quantity: Number(quantityInput) }, () => {
      cartStore.itemQuantityInputs.set(this.props.id, quantityInput)
    })
  }

  setItemQuantityStoreInput = (quantityInput: string): void => {
    // @TODO Add `&& parseInt(quantityInput, 10) <= product.maxQuantity`
    // when maxQuantity prop has been determined in Shopify admin
    const valid = /^\d+$/.test(quantityInput)
    if (quantityInput.length > 0 && !valid) {
      return
    }
    cartStore.itemQuantityInputs.set(this.props.id, quantityInput)
  }

  updateQuantity = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault()
    cartStore.itemQuantityInputs.set(this.props.id, this.state.quantity.toString())
    cartStore.updateOrAddItemToCart(this.props, cartStore.getInputQuantityForProduct(this.props.id))
  }

  get inputValue(): string {
    const input = cartStore.itemQuantityInputs.get(this.props.id)
    return input !== undefined ? input : ''
  }

  render(): React.ReactNode {
    const { available: inStock, displayUnavailable, productIsAvailable, className } = this.props
    const { quantity } = this.state
    const hasDeleteIcon = cartStore.items.get(this.props.id)

    let productStateButton
    if (displayUnavailable && !productIsAvailable) {
      productStateButton = <span className={`disabled ${className && className.includes('grid') ? 'grid' : 'list'}`}>Unavailable</span>
    } else if (!inStock) {
      productStateButton = <span className={`inactive ${className && className.includes('grid') ? 'grid' : 'list'}`}>Out of stock</span>
    } else {
      productStateButton = <AddToOrder product={this.props} />
    }

    return (
      <>
        <div className={`product-quantity ${this.props.className || ''} ${hasDeleteIcon ? 'has-delete-icon' : ''}`}>
          <form onSubmit={this.updateQuantity}>
            {productIsAvailable && inStock && (
              <div className={`product-quantity__inner`}>
                <div className='quantity'>
                  <button
                    type='button'
                    className='minus'
                    aria-label='Decrease'
                    onClick={() => this.setItemQuantityInput((quantity - 1).toString())}
                  >
                    &minus;
                  </button>
                  <input
                    placeholder='0'
                    className='input-box'
                    value={this.state.quantity}
                    onFocus={(event): void => {
                      // Hacky setTimeout to get this working in safari
                      const target = event.target
                      setTimeout(() => target.select(), 20)
                    }}
                    onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>): void => this.setItemQuantityInput(value)}
                    disabled={!inStock || !productIsAvailable}
                  />
                  <button
                    type='button'
                    className='plus'
                    aria-label='Increase'
                    onClick={() => this.setItemQuantityInput((quantity + 1).toString())}
                  >
                    &#43;
                  </button>
                </div>
                <RemoveFromCartIcon product={this.props} />
              </div>
            )}
            <div className='product-quantity__button'>{productStateButton}</div>
          </form>
        </div>
      </>
    )
  }
}
